import { FormControl } from '@angular/forms';
import { Component, Input } from '@angular/core';
import { NdmsSafeSubscriber } from '../../../../../../../shared/core/interfaces/ndms-safe-subscriber';

@Component({
  selector: 'ui-print-errors',
  templateUrl: './ui-print-errors.component.html',
  styleUrls: ['./ui-print-errors.component.scss']
})
export class UiPrintErrorsComponent extends NdmsSafeSubscriber {
  @Input() control: FormControl = new FormControl();
  @Input() errorMessages: any = {};

  constructor() {
    super();
  }

  get errors() {
    return this.control.errors;
  }
}
